import React from 'react';
import gaiaIcon from '../assets/gaia_icon.png';

interface AuthLayoutProps {
  children: React.ReactNode;
}

export const AuthLayout: React.FC<AuthLayoutProps> = ({ children }) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex flex-col">
      {/* Full-width header with logo */}
      <header className="w-full bg-white shadow-sm">
        <div className="flex justify-center py-6">
          <img 
            src={gaiaIcon} 
            alt="GAIA Logo" 
            className="h-16 w-auto"
          />
        </div>
      </header>
      
      {/* Main content area */}
      <main className="flex-1 flex items-center justify-center px-4 py-8">
        <div className="w-full max-w-md">
          {children}
        </div>
      </main>
      
      {/* Footer */}
      <footer className="w-full bg-white border-t border-gray-200">
        <div className="max-w-7xl mx-auto py-4 px-4 text-center">
          <p className="text-sm text-gray-600">
            © 2026 GAIA. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
};
